<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let guestinfo = data?.guestinfo;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>Guest Informations - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="offers">
	<div class="container-fluid py-md-5 py-5 px-0 offers-welcome position-relative">
		<div class="row g-0 justify-content-center mt-md-5 mt-4 mb-md-1 mb-1">
			<div class="col-md-10 px-md-5 px-3 text-center">
				<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">
					{guestinfo.name}
				</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica">
					{@html guestinfo.description}
				</p>
			</div>
		</div>
		<div class="container py-md-5 py-4 px-0">
			<div class="row g-0">
				{#each guestinfo.featured_images as img}
				<div class="col-md-6 px-3 mb-3 mt-3">
					<div class="ratio ratio-1x1 position-relative list-content">
						<img src="{img.path}" class="w-100 h-100 object-fit-cover">

						<div class="text-content position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center p-2 px-3">
							<a href="{img.description}" target="_blank" class="w-100 d-flex align-items-center justify-content-between text-decoration-none text-white">
								<div class="text-white ff-lola-bir fs-4">
									{img.title}
								</div>
								<span><i class="ph-light ph-arrow-right fs-1"></i></span>
							</a>
						</div>
					</div>
				</div>
				{/each}
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.offers-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #757fbd;
		width: 10%;
	}
	.list-content .text-content{
		background-image: linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0),rgba(0,0,0,0));
	}
	@media (max-width: 600px) {
		.offers-welcome .text-offer {
			position: absolute;
			top: 0%;
			left: 0%;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: end;
			padding: 20px;
			background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
		}
	}
</style>
